module.exports = __webpack_public_path__ + "img/icon_5.6d2d95f6.png";